import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Page } from "@ui/page/Page";
import { GD } from "../../GD";
import { TabItem, Tabs } from "@ui/tabs/Tabs";
import { DectaBrowser } from "./DectaBrowser";
import { DectaSessions } from "../conponents/list/DectaSessions";
import { Chargebacks } from "../chargebacks/Chargebacks";
import { Frauds } from "../conponents/list/Frauds";
import { Archive } from "../conponents/list/Archive";
import { Reco } from "../conponents/list/Reco";
import { VBox } from "@ui/box/Box";
import Spacer from "@ui/spacer/Spacer";
import { DECTA_TRANSACTIONS_ALLOWED_USER_IDS } from "../../permissions";
import { Archive as ArchiveIcon, CreditCard, FileSearch, FileText, Logs, RefreshCw, ShieldAlert, Undo2 } from "lucide-react";
import { DectaLogs } from "../conponents/SessionLog";

export const ProcessingPage = () => {
	useLocale();
	const [project] = GD.REQ_CURRENT_PROJECT.useRequest();
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);
	const label = project && project?.name + msg("processing_7843829d");
	const canViewDectaTransactions = !!user && DECTA_TRANSACTIONS_ALLOWED_USER_IDS.includes(user.id);

	return (
		<Page
			label={label ?? undefined}
			description={msg("processingFilesTransactionsChargebacksFraudsArchivesAndReconciliation")}
			icon={<RefreshCw size={20} />}>
			<VBox sx={{ flex: 1, minWidth: 0 }}>
				<Tabs selected={canViewDectaTransactions ? 0 : 1} variant="modern">
					{canViewDectaTransactions ? (
						<TabItem title={msg("payments")} icon={<CreditCard size={16} />}>
							<Spacer size="20px" />
							<DectaSessions />
						</TabItem>
					) : null}

					<TabItem title={msg("files")} icon={<FileText size={16} />}>
						<Spacer size="20px" />
						<DectaBrowser />
					</TabItem>

					<TabItem title={msg("chargebacks_655ad8a5")} icon={<Undo2 size={16} />}>
						<Chargebacks />
					</TabItem>

					<TabItem title={msg("frauds")} icon={<ShieldAlert size={16} />}>
						<Frauds />
					</TabItem>

					<TabItem title={msg("archive")} icon={<ArchiveIcon size={16} />}>
						<Spacer size="20px" />
						<Archive />
					</TabItem>

					<TabItem title={msg("reco_94714982")} icon={<FileSearch size={16} />}>
						<Spacer size="20px" />
						<Reco />
					</TabItem>

					{canViewDectaTransactions ? (
						<TabItem title={msg("logs")} icon={<Logs size={16} />}>
							<Spacer size="20px" />
							<DectaLogs />
						</TabItem>
					) : null}
				</Tabs>
			</VBox>
		</Page>
	);
};

// const RightSectionProcessing = () => {
// 	return (
// 		<Box
// 			sx={{
// 				display: "flex",
// 				flex: 1,
// 				minHeight: "0px",
// 				flexDirection: "column",

// 				gap: "10px",
// 			}}>
// 			{/* <Comments sectionType={0} targetId={1} targetType="client" />
// 			<EventsClients target_id={1} target_type="client" /> */}
// 		</Box>
// 	);
// };
